module.exports = function() {
  return new Worker(__webpack_public_path__ + "57ecf0a97c0d4e468e8c.worker.js");
};